<template>
    <img src="/assets/dipocaco/currency_x64.png" alt="" class="currency-icon" :style="style"/>
</template>

<script>
export default {
    name: "CurrencyIcon",
    props: ["style"]
};
</script>


<style scoped lang="scss">
.currency-icon {
    max-height: 1.5em;
}
</style>
